import styled, { css } from 'styled-components';
import { text2 } from '@ardoq/typography';
import { getInsetFocusRingBorderCSS } from '@ardoq/style-helpers';
import { colors, s4, space } from '@ardoq/design-tokens';
import { ICON_SELECTOR } from '@ardoq/icons';

/**
 * Tiny button that's only meant to be used inside filter pills.
 */
export const PillButton = styled.button<{
  $isOperator?: boolean;
  $isActive: boolean;
}>`
  ${text2};
  box-sizing: border-box;
  &:focus-visible,
  &.focus {
    ${getInsetFocusRingBorderCSS()};
  }
  cursor: pointer;
  min-height: 20px;
  padding: ${space.xsmall} ${space.small};
  transition: all 0.2s ease-in-out;
  user-select: none;
  gap: ${s4};
  ${({ $isOperator }) => css`
    background-color: ${
      $isOperator ? colors.surfaceDefaultSubtle : colors.surfaceDefault
    };
    &:hover {
      background-color: ${colors.surfaceHover};
    }
  `}
  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: ${colors.surfaceActive};
      ${ICON_SELECTOR} {
        color: ${colors.iconStrong};
      }
    `}
  border: none;
  display: flex;
  align-items: center;
  &:disabled {
    pointer-events: none;
    color: ${colors.textDisabled};
    background-color: ${colors.surfaceDisabled};
  }
`;

const StyledValuePillButton = styled(PillButton)`
  max-width: 250px;
  min-width: 0;

  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }
`;

export const ValuePillButton = ({
  children,
  ...props
}: React.ComponentProps<typeof PillButton>) => (
  <StyledValuePillButton {...props}>
    <span>{children}</span>
  </StyledValuePillButton>
);
